import { useCallback, useEffect, useReducer } from 'react';
import { Link } from 'react-router-dom';
import { CadranGlyph } from '../../components/CadranGlyph.js';
import { Step2Foyer } from './Step2Foyer.js';
import { Step3Appairage } from './Step3Appairage.js';
import { Step4Proches } from './Step4Proches.js';
import { Step5Message } from './Step5Message.js';
import { Step6Formule } from './Step6Formule.js';
import { SuccessScreen } from './SuccessScreen.js';
import { INITIAL_STATE, clearState, loadState, reducer, saveState } from './state.js';

const STEP_LABELS = ['', 'Compte', 'Foyer', 'Tablette', 'Famille', 'Premier mot', 'Formule'];

export function Onboarding() {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE, loadState);

  useEffect(() => {
    saveState(state);
  }, [state]);

  const next = useCallback(() => dispatch({ type: 'NEXT' }), []);
  const back = useCallback(() => dispatch({ type: 'BACK' }), []);

  const handleRestart = useCallback(() => {
    clearState();
    dispatch({ type: 'RESTART' });
  }, []);

  if (state.step === 'success') {
    return <SuccessScreen state={state} onRestart={handleRestart} />;
  }

  const curStep = state.step as number;

  return (
    <div className="wiz">
      {/* Header */}
      <div
        style={{
          padding: '18px 0',
          borderBottom: '1px solid var(--hairline-soft)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '56px',
          paddingRight: '56px',
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <CadranGlyph size={22} color="var(--ink)" />
          <span
            style={{ fontFamily: 'Fraunces Variable, serif', fontWeight: 500, fontSize: '20px' }}
          >
            Cadran
          </span>
        </Link>
        <Link to="/" className="small" style={{ color: 'var(--ink-muted)' }}>
          Quitter
        </Link>
      </div>

      {/* Stepper */}
      <div className="stepper">
        <div className="container">
          <ol className="stepper-grid" aria-label="Étapes de configuration">
            {[2, 3, 4, 5, 6].map((n) => {
              const isDone = curStep > n;
              const isCur = curStep === n;
              return (
                <li
                  key={n}
                  className={`step-pill${isDone ? ' done' : ''}${isCur ? ' cur' : ''}`}
                  aria-current={isCur ? 'step' : undefined}
                >
                  <div className="bar" />
                  <div className="meta">
                    <span className="n">{n - 1}</span>
                    <span className="lab">{STEP_LABELS[n]}</span>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>

      {/* Step content */}
      <div className="step-body">
        {state.step === 2 && (
          <Step2Foyer state={state} dispatch={dispatch} onNext={next} onBack={back} />
        )}
        {state.step === 3 && (
          <Step3Appairage state={state} dispatch={dispatch} onNext={next} onBack={back} />
        )}
        {state.step === 4 && (
          <Step4Proches state={state} dispatch={dispatch} onNext={next} onBack={back} />
        )}
        {state.step === 5 && (
          <Step5Message state={state} dispatch={dispatch} onNext={next} onBack={back} />
        )}
        {state.step === 6 && (
          <Step6Formule state={state} dispatch={dispatch} onNext={next} onBack={back} />
        )}
      </div>
    </div>
  );
}
